import React, { useId } from 'react';
interface LogoProps {
  className?: string;
}

/**
 * The existing sbwithkids.com badge mark: a scallop shell inside a ring of
 * letterspaced caps reading SANTA BARBARA / WITH KIDS.
 */
export function Logo({
  className = 'h-14 w-14'
}: LogoProps) {
  const id = useId().replace(/:/g, '');
  const topArc = `top-${id}`;
  const bottomArc = `bottom-${id}`;
  return <svg viewBox="0 0 120 120" className={className} role="img" aria-label="Santa Barbara With Kids" fill="none" data-id="element-146" data-mp="msuos2321tc8">
      <defs data-id="element-147" data-mp="rqmkl76tlzlp">
        <path id={topArc} d="M14,60 A46,46 0 0 1 106,60" data-id="element-148" data-mp="rr606h900bwk" />
        <path id={bottomArc} d="M18,60 A42,42 0 0 0 102,60" data-id="element-149" data-mp="dsxxdspa6gdh" />
      </defs>

      <text fill="currentColor" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '13px',
      fontWeight: 600,
      letterSpacing: '2.6px'
    }} data-id="element-150" data-mp="htrnmsq7479j">
        <textPath href={`#${topArc}`} startOffset="50%" textAnchor="middle" data-id="element-151" data-mp="32kiaf1cmbzfq">
          SANTA BARBARA
        </textPath>
      </text>
      <text fill="currentColor" style={{
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '13px',
      fontWeight: 600,
      letterSpacing: '3.4px'
    }} data-id="element-152" data-mp="1evsz84h23a24">
        <textPath href={`#${bottomArc}`} startOffset="50%" textAnchor="middle" data-id="element-153" data-mp="1nx0wqkbr06v5">
          WITH KIDS
        </textPath>
      </text>

      <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-154" data-mp="1xtvs4ucq5r57">
        <path d="M60 40c14.5 0 25 9.5 25 21.5 0 3.2-1.1 5.6-3 6.9-6.4 4.4-14 6.6-22 6.6s-15.6-2.2-22-6.6c-1.9-1.3-3-3.7-3-6.9C35 49.5 45.5 40 60 40Z" data-id="element-155" data-mp="1strb937wmueg" />
        <path d="M60 40v34.9" strokeWidth="1.4" data-id="element-156" data-mp="27li26ndbtk6d" />
        <path d="M49.5 42.6 44 71.5M70.5 42.6 76 71.5" strokeWidth="1.4" data-id="element-157" data-mp="22lnbokxgqwlu" />
        <path d="M39.6 48.4 36.4 66M80.4 48.4 83.6 66" strokeWidth="1.4" data-id="element-158" data-mp="2gju0lbkfpm9d" />
        <path d="M56 40.4c0-3 1.8-5 4-5s4 2 4 5" strokeWidth="1.8" data-id="element-159" data-mp="2gi0pnk2sgfvk" />
      </g>
    </svg>;
}